import React from "react";
import { Link } from "react-router-dom";
import { Flag, ArrowRight } from "lucide-react";
import { useGiveawayState } from "@/lib/useGiveaway";

const COPY = {
  teaser: { kicker: "Veteran HVAC Giveaway 2026", head: "Something Big Is Coming This Veterans Day", sub: "We're giving a brand-new HVAC system + professional installation to a Space Coast veteran in need. Nominations & voting open October 1.", cta: "Learn More" },
  voting: { kicker: "Veteran HVAC Giveaway — Now Open", head: "Nominate a Veteran. Cast Your Vote.", sub: "Help us give one deserving veteran a brand-new HVAC system with professional installation. Nominations & public voting open through October 31.", cta: "Nominate & Vote" },
  review: { kicker: "Veteran HVAC Giveaway", head: "Voting Has Closed — Winner Coming Veterans Day", sub: "Thank you to everyone who nominated and voted. We're verifying the results and will announce our winner on November 11.", cta: "See the Nominees" },
  winner: { kicker: "🏆 Happy Veterans Day", head: "Meet Our Veteran Giveaway Winner", sub: "Today we honor the veteran receiving a brand-new HVAC system and professional installation from Aquila Air & Heating.", cta: "See the Winner" },
  closed: { kicker: "Veteran HVAC Giveaway", head: "Meet Our Veteran Giveaway Winner", sub: "See the veteran who received a brand-new HVAC system and professional installation from Aquila Air & Heating.", cta: "See the Winner" },
};

export default function GiveawayHomeStrip() {
  const { data } = useGiveawayState();
  const c = COPY[data?.phase];
  if (!c) return null;
  return (
    <section className="relative overflow-hidden bg-[#0a1730] text-white" data-testid="home-giveaway-strip">
      <div className="absolute inset-y-0 right-0 w-1/2 hidden md:block" aria-hidden="true">
        <img src="/giveaway/hero.jpg" alt="" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1730] via-[#0a1730]/70 to-transparent" />
      </div>
      <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-launch via-launch/60 to-transparent" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-launch"><Flag className="h-4 w-4" /> {c.kicker}</p>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold leading-tight tracking-tight">{c.head}</h2>
          <p className="mt-3 text-slate-200 leading-relaxed">{c.sub}</p>
          <Link to="/veteran-hvac-giveaway" data-testid="home-giveaway-strip-cta" aria-label="Learn more about the Veteran HVAC Giveaway"
            className="mt-6 inline-flex items-center gap-2 bg-launch hover:bg-launch-dark text-white font-bold py-3 px-7 min-h-[48px] rounded-md shadow-lg transition-colors">
            {c.cta} <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
